import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { View } from 'react-native';

import * as Actions from '../../store/Actions';

class LogoutScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    props.actions.logout(() => {
      props.navigation.navigate('Language');
    });
  }

  render() {
    return <View />;
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutScreen);
